// Custom type for localization entries to replace any with a more specific type.
type LocalizationValue = string | string[] | Record<string, string | string[]>;

type LocInterface<T extends Record<string, LocalizationValue>> = {
  addDefault: (data: T) => void;
  addLanguage: (lang: string, data: T) => void;
  getLanguage: (lang?: string) => T;
  translateWithParams: (key: string, params: Record<string, string>) => string;
};

export function createLocalization<T extends Record<string, LocalizationValue>>(): LocInterface<T> {
  const dict: Record<string, T> = {};

  return {
    addDefault: (data: T) => {
      dict['en-us'] = Object.assign(dict['en-us'] || {}, data);
    },
    addLanguage: (lang: string, data: T) => {
      const normalizedLang = lang.toLowerCase();
      dict[normalizedLang] = { ...dict[normalizedLang], ...data };
    },
    getLanguage: (_lang?: string) => {
      const lang = String(_lang).toLowerCase();
      if (lang in dict) return dict[lang];
      const shortLang = lang.slice(0, 2);
      if (shortLang in dict) return dict[shortLang];
      return dict['en-us'];
    },
    translateWithParams: (valueWithParams: string, params: Record<string, string>): string => {
      let value: string = valueWithParams;
      if (value) {
        Object.keys(params).map(param => {
          const repStr = params[param];
          const regex = new RegExp(`{{${param}}}`, 'g');
          value = value.replace(regex, repStr);
        });
      }
      return value as string;
    },
  };
}
